/**
 * Boolean feature flag: runtime env var (via `env.js` -> `window.__X`) with a
 * `VITE_X` fallback for local dev, unlike `mapbox.ts`'s `readConfig` this
 * defaults instead of throwing, since a flag is opt-out, not required config.
 */
const readBooleanFlag = (windowKey: string, envKey: string, defaultValue: boolean): boolean => {
  const runtimeValue = typeof window !== 'undefined' && (window as unknown as Record<string, unknown>)[windowKey];
  const value = runtimeValue || import.meta.env[envKey];
  if (!value) return defaultValue;
  return value !== 'false' && value !== '0';
};

export const SOW_PARSER_ENABLED = readBooleanFlag('__SOW_PARSER_ENABLED', 'VITE_SOW_PARSER_ENABLED', true);

// Opt-in (defaults off) — unlike SOW_PARSER_ENABLED, this gates a brand-new,
// unreleased feature under staged rollout rather than an already-shipped one.
export const DOWNLOAD_LOGS_ENABLED = readBooleanFlag('__DOWNLOAD_LOGS_ENABLED', 'VITE_DOWNLOAD_LOGS_ENABLED', false);
